import { Toggle } from '@warp-ds/react/components/toggle';
import cn from 'classnames';

interface CustomRadioGroupProps {
    className?: string;
    value: string;
    onChange: (option: { value: string; label: string }) => void;
    options: Array<{
        value: string;
        label: string;
    }>;
    legend: string;
    hideLegend?: boolean;
    dir?: 'col' | 'row';
}

export const CustomRadioGroup = ({ legend, hideLegend, className, options, value, onChange, dir = 'col' }: CustomRadioGroupProps) => (
    <fieldset className={cn(className, 'flex flex-col gap-8')}>
        <legend className={hideLegend ? 'sr-only' : 'flex flex-col t4 w-full'}>{legend}</legend>
        <Toggle
            className={cn('flex', `flex-${dir}`, {
                'gap-6': dir === 'col',
                'gap-12 p-4 pt-8 ': dir === 'row',
            })}
            type="radio"
            options={options}
            selected={options.filter((option) => option.value === value)}
            onChange={onChange}
        />
    </fieldset>
);
